var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.offsets,"item-value":"value","item-text":"name","label":_vm.label,"required":_vm.required,"dense":_vm.dense,"outlined":_vm.outlined,"hide-details":_vm.hideDetails,"disabled":_vm.disabled,"readonly":_vm.readonly},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }